import { FC, useRef, useEffect } from 'react'
import {
  Button,
  Uploader as RsuiteUploader,
  UploaderProps as RsuiteUploaderProps
} from 'rsuite'
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro'
import { Media } from '@rsuite/icons'
import './Uploader.scss'

interface UploaderProps extends RsuiteUploaderProps {
  fileInfo?: string;
  isVideo?: boolean;
  isPdf?: boolean;
}

const Uploader: FC<UploaderProps> = ({
  fileInfo,
  isVideo,
  isPdf,
  ...props
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load()
    }
  }, [fileInfo])

  const renderMedia = () => {
    if (!fileInfo) {
      return isVideo ? (
        <Media className="uploader-btn" />
      ) : (
        <CameraRetroIcon className="uploader-btn" />
      )
    }
    if (isPdf) {
      return <embed src={fileInfo} width="70%" height="100%" title="Pdf" />
    }

    return isVideo ? (
      <video ref={videoRef} width="100%" height="100%" src={fileInfo} controls>
        <track kind="captions" src="" />
      </video>
    ) : (
      <img src={fileInfo} alt="file" width="70%" height="100%" />
    )
  }

  return (
    <RsuiteUploader
      className="uploader"
      multiple={false}
      fileListVisible={false}
      {...props}
    >
      <Button>{renderMedia()}</Button>
    </RsuiteUploader>
  )
}

export default Uploader
